<template>
<div id="hc_consulta" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12" >
        <base-material-card color="primary" icon="assignment" title="Consulta de Pedimentos WS para generar Hoja de Cálculo" class="elevation-1 px-5 py-3" >
          <br>
          
              <v-card-text>
                <v-card-title>
                  <span class="headline" ></span>
                </v-card-title>
                <v-form ref="form1" lazy-validation>
                  <v-container grid-list-md text-xs-center>
                    <v-row row wrap>
                      <v-col sm="6" md="6" lg="6" >
                        <v-autocomplete v-model="model.tipo_reporte" :items="tipos" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Tipo de Consulta" @change="clear_values()" :rules="[rules.required]" >
                        </v-autocomplete>
                      </v-col>                      
                    </v-row>

                    <v-row v-if="model.tipo_reporte == 1" row wrap>
                      <v-col sm="12" md="6" lg="6" >
                        <v-text-field v-model="model.pedimento" label="Pedimento" prepend-icon="fa-search" :rules="[rules.required]" ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row v-if="model.tipo_reporte == 3" row wrap>
                      <v-col sm="12" md="6" lg="6" >
                        <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                          <template v-slot:activator="{ on }" >
                            <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" :rules="[rules.required, validaAnio, validaFecha]" v-mask="'####-##-##'" >
                            </v-text-field>
                          </template>

                          <v-date-picker v-model="model.fecha_de" color="secondary"  scrollable locale="es-mx" @input="menu3 = false" >
                            <v-spacer />

                            <v-btn color="secondary" x-small @click="menu3 = false" >
                              Cancelar
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col sm="12" md="6" lg="6" >
                        <v-menu offset-x ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                          <template v-slot:activator="{ on }" >
                            <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" :rules="[rules.required, validaAnio, validaFecha]" v-mask="'####-##-##'" >
                            </v-text-field>
                          </template>
                          <v-date-picker v-model="model.fecha_a" color="secondary"  scrollable locale="es-mx" @input="menu4 = false" >
                            <v-spacer />

                            <v-btn color="secondary" x-small @click="menu4 = false" >
                              Cancelar
                            </v-btn>
                          </v-date-picker>
                        </v-menu>

                      </v-col>
                    </v-row>
                    
                   
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>                
                <v-spacer></v-spacer>
                <v-btn rounded color="success" @click="get_data_view()" :loading="loading" >
                  <v-icon>done</v-icon>Consultar
                </v-btn>
              </v-card-actions>
              <v-card-text>
                <v-client-table ref="vuetable" :data="data_view.datos" :columns="data_view.columns" :options="data_view.options" class="elevation-2 pa-2 scroll-table" >
                  <template slot="noResults" >
                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                  </template>
                  <template slot="patente" slot-scope="props" >
                    {{ props.row.patente.toString().substring(1) }}
                  </template>
                  <template slot="seccion_aduanera" slot-scope="props" >
                    {{ props.row.seccion_aduanera.toString().substring(1) }}
                  </template>
                  <template slot="pedimento" slot-scope="props" >
                    {{ props.row.no_pedimento.toString().substring(9) }}
                  </template>
                  
                  <template slot="actions_view" slot-scope="props" > 
                      <v-btn x-small fab color="primary" title="Vista Previa" :to="'/formatos/hc_formato/'+props.row.id" >                                         
                        <v-icon>search</v-icon>
                      </v-btn>                                          
                  </template>

                </v-client-table>
              </v-card-text>
              <v-card-text>
                <div class="card-title font-weight-light" >Hojas de Cálculo Generadas:</div>
                        
                        <v-refresh-button :funcion="cargarReportesDS" />
                        <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2" >
                            <template slot="noResults" >
                                <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                            </template>

                            <template slot="actions" slot-scope="props" >
                                <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadFile(props.row.filename)" >
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                                <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                                    <v-icon dark>delete</v-icon>
                                </v-btn>
                            </template>
                        </v-client-table>
                    </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
 
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";
export default {
    components: {
        "v-refresh-button": RefreshButton,
    },
  created: function() {
    this.URL = this.$hostname + "reportes/";
    this.loading = false;
    this.model.usuario = this.$local_storage.get("id_usuario");
    this.model.rfc = this.$local_storage.get("rfc");
    var tipoUsuario = this.$local_storage.get("tipo_usuario");    
    if (tipoUsuario=="Soporte" || tipoUsuario=="Super Usuario"){            
            this.permisoEliminar = true;
        }
    this.cargarReportesDS();    
  },
  data: () => ({    
    permisoEliminar: false,
    tab: null,        
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Consulta de Pedimentos para Hoja de Cálculo",
        disabled: true,
        to: ""
      }
    ],
    tipos: [{
      "id": 1,
      "text": "Por Pedimento"
    }, {
      "id": 3,
      "text": "Por Fechas"
    }],
   
    loading: true,
    show_loading: true,
    model: {
      rfc: "",
      usuario: "",
      pedimento: "",
      fecha_de: "",
      fecha_a: "",
      lista: "",
      reporte_url: "/reportes_vucem/consultar_pedimentos_simple/",
      nombre_reporte: "Pedimentos Detalle",
      tipo: "Pedimentos Detalle",
      tipo_reporte: "",
    },
    menu3: false,
    menu4: false,
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    data_view: {
      datos: [],
      columns: ['no_pedimento','tipo_operacion','clave_documento',
        'patente','pedimento','seccion_aduanera','actions_view'
      ],
      options: {
        filterable: ['no_pedimento','tipo_operacion','clave_documento',
        'patente','seccion_aduanera'
        ],
        sortable: [],

        headings: {          
          no_pedimento: 'No Pedimento',          
          tipo_operacion: 'Tipo Operación',          
          clave_documento: 'Clave Documento',
          seccion_aduanera: 'Sección Aduanera',
          patente: 'Patente',   
          pedimento: 'Pedimento',          
          actions_view: 'Opciones'
        }
      }
    },
    datos:[],
    columns: ["id","fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
        options: {
            filterable: ["id","fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
            sortable: ["id","fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

            headings: {
                id:"No. Proceso",
                fecha_solicitud: "Solicitado",
                usuario_email: "Usuario",
                nombre_reporte: "Reporte",
                criterio: "Criterio de Búsqueda",
                fecha_generacion: "Generado",
                estatus: "Estatus",
                error: "Error",
                actions: "Descargar"
            }
        },
  }),
  methods: {
    validaFecha: function(fecha){
        if (fecha == "Invalid date")
            return "Fecha no válida."
        else 
            return true;
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    validaDias: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
        if (Math.abs(diferencia) > 31)
          return "Periodo máximo de consulta 31 dias. Favor de verificar."
      }
      return true;
    },   
          
    get_data_view: function() {
      if (!this.$refs.form1.validate()) {
        //Alguna operación o mensaje
      } else {
        if (this.model.tipo_reporte == 4 && this.model.lista == '') {
          this.$swal({
            type: "info",
            title: "Información",
            text: "Debes ingresar al menos un elemento a la lista",
            footer: ""
          });

          return false;
        }
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var data = this.model;
        if (data.pedimento == '') delete(data['pedimento']);
        if (data.fecha_de == '') delete(data['fecha_de']);
        if (data.fecha_a == '') delete(data['fecha_a']);
        if (data.lista == '' || data.lista == []) {
          delete(data['lista'])
        } else {
          if (data.tipo_reporte == 4) {
            data['lista'] = this.get_array_lista(data['lista'])
          }
        }
        data['preview'] = true;

        axios({
            method: "post",
            url: this.$hostname + "reportes_vucem/consultar_pedimentos_simple/",
            data: data
          })
          .then(response => {
            this.to_download = [];
            this.data_view.datos = response.data;
            if (data.tipo_reporte == 4) {
              this.model.lista = '';
              this.lista_filtrada = [];
            }
          })
          .catch(error => {
            console.log(error);
            let mensaje;
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
            } else {
              mensaje = "Reporte demasiado grande para vista previa. Intenta con un periodo más corto";
            }

            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: mensaje,
              footer: ""
            });
          }).then(() => {
            this.$root.$dialogLoader.hide();
          });
      }
    },
    cargarReportesDS: function () {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        let data = {
            rfc: this.model.rfc,
            "tipo": "HojaCalculo"
        };
        axios.post(this.URL + "get_reportes/", data)
            .then(res => {
                if (typeof res.data !== "undefined") {
                    this.datos = res.data;
                    this.datos.sort(function (a, b) {
                        //Ordenar por fecha más reciente
                        return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud);
                    });
                    for (var k in this.datos) {
                        this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
                        this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
                        this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
                        this.datos[k].criterio = this.getCriterioPredeterminadosDS(this.datos[k].criterio);
                    }
                }
            })
            .catch(err => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los reportes ds.",
                    footer: ""
                });
                console.log(err);

            }).then(() => {
                this.$root.$dialogLoader.hide();
            });
    },
    getEstatus: function (estatus) {
        var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
        if (estatus in arr_estatus)
            return arr_estatus[estatus];
        else
            return "N/A";
    },
    getCriterioPredeterminadosDS: function (criterio) {
        try {
            if (criterio != undefined && criterio.toString().trim() != "") {
                var params = JSON.parse(criterio);
                return "NoPedimento: " + params.no_pedimento;
            } else {
                return "N/A";
            }
        } catch (error) {
            console.log(error);
            return "N/A-error";
        }
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    clear_values() {
      this.model.pedimento = '';
      this.model.fecha_de = '';
      this.model.fecha_a = '';
    },
    downloadFile: function (key) {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var datos = {
            id: key,
            bucket: "production.econnect.ds"
        }
        axios.post(this.$hostname + 's3/download_url/', datos)
            .then((res) => {
                if (typeof res.data !== 'undefined') {
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = res.data.mensaje;
                    a.target = "_blank";
                    a.click();
                    a.parentNode.removeChild(a);

                } else {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                        footer: '',
                    });
                }
            })
            .catch((error) => {
                var mensaje = "Ocurrió un error al descargar el archivo";
                if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                    mensaje = error.response.data.mensaje;
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: mensaje,
                    footer: '',
                });
                console.log(error);
            }).then(() => {
                this.$root.$dialogLoader.hide();
            });
    },
    eliminarReporte: function (idreporte) {
        this.$swal({
          type: "info",
          title: "Cuidado",
          text: "¿Está seguro de eliminar el reporte con No. Proceso: "+idreporte+"?",
          footer: "",
          showCancelButton: true,
          cancelButtonColor: "#d33",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar"
      }).then(result => {
          if (result.value) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id_reporte: idreporte,                
            }
            axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
                .then((res) => {
                this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "El reporte se eliminó correctamente",
                        footer: ""
                    });
                })
                .catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.cargarReportesDS();
                });
          }
      });
    },
        
  },
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small ;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small ;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}

.text-number {
    text-align: right;
}
</style>
